import { RbGtmClient } from '@redbubble/next-analytics/gtm';
export var trackGA4GlobalNavViewSubCategory = function (item, context) {
    var _a;
    RbGtmClient.track({
        event: 'interact_element',
        action: 'click',
        is_outbound: false,
        is_nav: true,
        page_location: window.location.pathname,
        element: 'global_nav',
        element_text: item.label,
        element_url: (_a = item.action.parameters) === null || _a === void 0 ? void 0 : _a.url,
        context: JSON.stringify(context),
    });
};
export var trackGA4GlobalNavViewCategory = function (item, context) {
    var _a;
    RbGtmClient.track({
        event: 'interact_element',
        action: 'expand',
        is_outbound: false,
        is_nav: true,
        page_location: window.location.pathname,
        element: 'global_nav',
        element_text: item.label,
        element_url: (_a = item.action.parameters) === null || _a === void 0 ? void 0 : _a.url,
        context: JSON.stringify(context),
    });
};
